var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('giphy-viewer',{attrs:{"gif":_vm.gif}}),_c('div',{staticClass:"mt-2"},[_c('b-btn',{attrs:{"variant":"primary","block":"","pill":"","size":"lg"},on:{"click":function($event){return _vm.selectGif(_vm.gif)}}},[_vm._v(" "+_vm._s(_vm.$t("Select GIF"))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }